import React, { useContext, useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
} from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import MenuItemRenderer from './components/MenuItemRenderer/MenuItemRenderer';
import useLogicMechanismSelect from './Hooks/useLogicMechanismSelect';
import { SelectProps } from './variables/SelectProps';
import { ValueSetter } from './variables/ValueSetter';
import { MenuItemStyleSetter } from './variables/MenuItemStyleSetter';
import ErrorSupportForAllMui from '../ErrorSupportForAllMui/ErrorSupportForAllMui';
import useLiftStateValue from './Hooks/useLiftStateValue';
import useSetEditableState from './Hooks/useSetEditableState';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import ClickAwayListener from 'react-click-away-listener';
import i18next from 'i18next';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const CustomizableSelect = ({
  SelectableDataArray, // eg. [{ItemContent:'',ItemValue:''}]
  label,
  isSingle = false,
  onChange,
  errors,
  name,
  AllFieldsRealTimeCheck,
  CheckInReal,
  disabled,
  editable,
  value,
  GetSelectedValue,
  swipleToLeftTitle=false,
  CompleteOutPut = false,
  isSmall = true,
}) => {


  const isEnglish = i18next.language === 'en';


 
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop


  const [UiValue, setUiValue] = React.useState(
    isSingle ? '' : []
  );

  const [openSelect, setOpenSelect] = useState(false);

  const GlobalConstants = useContext(GlobalContext);
  const selectProps = SelectProps(
    disabled,
    UiValue,
    label,
    setUiValue,
    isSingle,
    CheckInReal,
    AllFieldsRealTimeCheck,
    name,
    errors,
    SelectableDataArray,
    isEnglish
  );
  useLogicMechanismSelect(
    onChange,
    isSingle,
    UiValue,
    SelectableDataArray,
    CompleteOutPut
  );
  useSetEditableState(
    editable,
    value,
    SelectableDataArray,
    setUiValue,
    onChange
  );
  useLiftStateValue(
    GetSelectedValue,
    UiValue,
    SelectableDataArray
  );
  const MemoListSelect = React.useMemo(() => {
    return SelectableDataArray?.map((element) => (
      <MenuItem
        sx={MenuItemStyleSetter(isEnglish)}
        value={ValueSetter(isSingle, element)}
        key={GlobalConstants.uuidV4()}
        onClick={(event) => {
          event.stopPropagation();
          if (isSingle) {
            setOpenSelect(false);
          }
        }}
        onSelect={(event) => {
          event.stopPropagation();
          if (isSingle) {
            setOpenSelect(false);
          }
        }}
        onChange={(event) => {
          event.stopPropagation();
          if (isSingle) {
            setOpenSelect(false);
          }
        }}
      >
        <MenuItemRenderer
          isSingle={isSingle}
          UiValue={UiValue}
          element={element}
        />
      </MenuItem>
    ));
  }, [SelectableDataArray, UiValue]);
  return (
    <React.Fragment>
      <FormControl
        fullWidth
        dir={
          swipleToLeftTitle
            ? 'ltr'
            : !isEnglish
            ? 'rtl'
            : {}
        }
        sx={{
          '& *': {
            fontFamily: 'IranYekan',
          },
          flexWrap: 'wrap',
          overflowWrap: 'break-word',
          wordBreak: 'break-all',
        }}
        {...(screenWidth < 1024 &&
          isSmall && { size: 'small' })}
      >
        <InputLabel
          id="demo-simple-select-label"
          color="colorPrimer"
          sx={{
            textAlign: isEnglish ? 'left' : 'right',
            right: isEnglish ? 'auto' : 42,
            left: isEnglish ? 0 : 'auto',
            transformOrigin: isEnglish ? 'left' : 'right',
            '&.MuiInputLabel-shrink': {
              right: '32px !important', // Other styles...
            },
            color:
              errors && !!errors[name]
                ? '#D32F2F !important'
                : '',
          }}
        >
          {label ?? ''}
        </InputLabel>

        <Select
          {...selectProps}
          {...(isSmall &&
            screenWidth < 1024 && { size: 'small' })}
          open={openSelect}
          onClick={() => {
            if (!disabled) {
              setOpenSelect(true);
            }
          }}
          sx={{ position: 'relative' }}
        >
          <Button
            startIcon={
              <CheckCircle
                sx={{
                  fill: themeColors.ColorPrimary,
                }}
              />
            }
            fullWidth
            variant="outlined"
            color="success"
            onClick={(event) => {
              event.stopPropagation();
              setOpenSelect(false);
            }}
            sx={{
              borderRadius: '0',
              minHeight: '50px',
              marginTop: '-.5em',
              position: 'sticky',
              top: 0,
              backgroundColor: 'white',
              zIndex: 999999,
              borderInlineColor: 'unset',
              borderRadius: '.2em',
            }}
            size="large"
            disableRipple
          ></Button>
          {/* <ClickAwayListener
            onClickAway={() => {
              console.log("click away");
              setOpenSelect(false);
            }}
          > */}
          {MemoListSelect}
          {/* </ClickAwayListener> */}
        </Select>

        {errors && !!errors[name] && (
          <ErrorSupportForAllMui label={label} />
        )}
      </FormControl>
    </React.Fragment>
  );
};

export default CustomizableSelect;
